export const MAX_INVALID_ATTEMPTS = 3;
export const LOCK_TIME_IN_MINUTES = 2;
export const PHONE_MAX_LENGTH = 10;
export const CHECK_DIGIT_REGEX = /^\d+$/;
export const BACK_BUTTON = "Back";
